import React, { BaseSyntheticEvent, useEffect, useState } from 'react';
import { translate } from 'javascripts/translations/i18n';
import styled from 'styled-components';
import { Button } from '@companycam/slab-web';
import Modal from 'components/shared/DesignSystem/Modal';
import { Toggle as Switch } from 'components/core/forms';
import Common from 'helpers/intl-common';
import steven from 'helpers/steven';
import { PagePdfExportConfig } from './hooks/usePagePdfExport';

const StyledModal = styled(Modal)`
  width: 553px;
  display: flex;
  flex-direction: column;
`;

const switchRowStyle = {
  justifyContent: 'space-between',
  marginBottom: 16,
};

const PagePdfExportModal = ({
  isOpen,
  onRequestClose,
  onExportClick,
  loading,
}: {
  isOpen: boolean;
  onRequestClose: () => void;
  onExportClick: (exportOptions: PagePdfExportConfig) => void;
  loading: boolean;
}) => {
  const [includeCoverPage, setIncludeCoverPage] = useState(false);

  useEffect(() => {
    if (!isOpen) {
      setIncludeCoverPage(false);
    }
  }, [isOpen]);

  const handleExportClick = () => {
    steven.elementClicked({
      id: 'project_page_export_pdf',
      content: Common.export.defaultMessage,
      action: 'project_page_export_pdf_clicked',
      type: 'button',
    });
    onExportClick({
      includeCoverPage,
    });
  };

  return (
    <StyledModal
      isOpen={isOpen}
      isClosable
      onRequestClose={onRequestClose}
      title={translate('common.exportToPdf')}
      className="modal-content-wrap"
      style={undefined}
    >
      <Switch
        label={translate('projects.pages.exportPdf.includeCoverPage')}
        accessibilityLabel={translate(
          'projects.pages.exportPdf.includeCoverPage',
        )}
        name="includeCoverPage"
        checked={includeCoverPage}
        onChange={(e: BaseSyntheticEvent) => {
          steven.elementClicked({
            id: 'project_page_export_pdf_cover_page_toggle',
            content: 'projects.pages.exportPdf.includeCoverPage',
            action: `project_page_export_pdf_cover_page_${
              e.target.checked ? 'on' : 'off'
            }`,
            type: 'button',
          });
          setIncludeCoverPage(e.target.checked);
        }}
        style={switchRowStyle}
        labelOff={translate('common.toggleOff')}
        labelOn={translate('common.toggleOn')}
        disabled={loading}
        id={undefined}
        tooltip={undefined}
        lightSwitchTooltip={undefined}
        size={undefined}
        dark={undefined}
      />

      <div className="btn-container">
        <Button color="primary" onClick={handleExportClick} loading={loading}>
          {translate('common.export')}
        </Button>
      </div>
    </StyledModal>
  );
};

export default PagePdfExportModal;
